export interface IAddress {
    name: string;
    line1: string;
    line2: string;
    line3: string;
    city: string;
    state: string;
    postalCode: string;
    postalCodePlus4: string;
    countryId: string;
    countryName: string;
    email: string;
}

export class Address implements IAddress {
    name = null;
    line1 = null;
    line2 = null;
    line3 = null;
    city = null;
    state = null;
    postalCode = null;
    postalCodePlus4 = null;
    countryId = null;
    countryName: string;
    email: null;
}
